export const getCompanyCodeFromUrl = (isLocal, host) => {
  let companyCode = import.meta.env.VITE_SPA_OSPREY_DEFAULT_COMPANY_CODE || 'test'
  let subdomain = `${import.meta.env.VITE_SPA_OSPREY_ENV || 'dev'}---${companyCode}`

  if (!isLocal) {
    // host will be 'environmentName---companyCode.ospreyapproach.com' or 'companyCode.ospreyapproach.com'
    subdomain = host.split('.')[0]

    if (subdomain.includes('---')) {
      const parts = subdomain.split('---')
      companyCode = parts[1]
    } else {
      companyCode = subdomain
    }
  }

  return { companyCode, subdomain }
}

export const getDatabaseSuffixFromUrl = (isLocal) => {
  let databaseSuffix = import.meta.env.VITE_SPA_OSPREY_DEFAULT_DATABASE_SUFFIX || 'main'

  if (!isLocal) {
    const pathname = window?.location?.pathname || ''
    const pathnameParts = pathname.split('/').filter((i) => !!i)
    if (pathnameParts[0] && pathnameParts[0] !== '#') {
      databaseSuffix = pathnameParts[0]
    }
  }

  return { databaseSuffix }
}
